import { Component, OnInit } from "@angular/core";
import { BillingService } from "../billing.service";
import { LoginService } from "../login.service";
import { PatientsService } from "../patients.service";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";

@Component({
    selector: "app-billing-reports",
    templateUrl: "./billing-reports.component.html",
    styleUrls: ["./billing-reports.component.scss"],
    standalone: false
})
export class BillingReportsComponent implements OnInit {
  isLoading: boolean = false;
  columns = new Array(7);
  searchResults: any;
  documentType: any;
  fromDate: any;
  fromDateC: any;
  toDate: any;
  toDateC: Date;
  doctorUID: any;
  doctorUIDc = '0';
  currentSortColumn: string | null = null;
  sortDirection = "asc";
  paid = true;
  today = new Date();
  invoices = '0';
  checksData: any[];
  loadingCheck:number = null;
  

  documentTypes = [
    { label: "הכל", value: "All" },
    { label: "חשבונית מס / קבלה", value: 320 },
    { label: "קבלה", value: 400 },
    { label: "חשבונית מס", value: 305 },
    { label: "חשבונית זיכוי", value: 330 },
    { label: "הצעת מחיר", value: 10 },
  ];
  constructor(
    public billingService: BillingService,
    public loginService: LoginService,
    public patientsService: PatientsService,
    private router: Router,
    private http: HttpClient
  ) {
    this.loginService.loginMissing();
  }

  ngOnInit(): void {
    this.getDoctors();
    this.toDateC = this.today;
  }

  // For a multiple doctors clinic:
  getDoctors(): any {
    return this.loginService.clinicUsers;
  }

  // For a single doctor clinic:
  getDoctor(): any {
    return this.loginService.userBilling;
  }

  search() {
    this.isLoading = true;
    const fromDate = new Date(this.fromDate);
    fromDate.setHours(0, 0, 0, 0);

    const toDate = new Date(this.toDate);
    toDate.setHours(23, 59, 59, 999);

    const params = {
      doctorUID: this.doctorUID,
      documentType: this.documentType,
      fromDate: fromDate.toISOString(),
      toDate: toDate.toISOString(),
    };
    this.billingService.billingReports(params).subscribe(
      (result) => {
        this.isLoading = false;
        this.searchResults = result;
      },
      (error) => {
        this.isLoading = false;
        console.error("Failed to produce invoice:", error);
      }
    );
  }

  goToSettings() {
    this.router.navigate(["/settings"]);
  }

  goToBilling() {
    this.router.navigate(["/billing"]);
  }

  printBillingReport() {
    let printUrl = `api/print/report/${this.documentType}/${this.fromDate.toISOString()}/${this.toDate.toISOString()}/${
      this.doctorUID
    }`;
    window.open(printUrl);
  }

  sortData(property: string) {
    if (this.currentSortColumn === property) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortDirection = "asc";
      this.currentSortColumn = property;
    }

    this.searchResults.sort((a, b) => {
      const valueA = new Date(a[property]).getTime();
      const valueB = new Date(b[property]).getTime();

      return this.sortDirection === "asc" ? valueA - valueB : valueB - valueA;
    });
  }

  getTotalAmount(): number {
    if (!this.searchResults) {
      return 0;
    }
  
    const adjustedPrices = this.searchResults.map(invoice => ({
      ...invoice,
      Price: this.adjustPrice(invoice),
    }));
    
    return adjustedPrices.reduce((sum, result) => sum + result.Price, 0);
  }
  
  
  adjustPrice(invoice: any): number {
    const subjectKeyword = "זיכוי חשבונית";
    const typeName = "קבלה";
    
    if (invoice.Subject.includes(subjectKeyword) && invoice.TypeName === typeName) {
      return invoice.Price * -1; // Return negative price
    }
    return invoice.Price; // Otherwise, return the price as is
  }

  async openPdf(url: string) {
    this.http.get(url, { responseType: "blob" }).subscribe(
      (blob) => {
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, "_blank");
      },
      (error) => {
        console.error("Error downloading the PDF:", error);
      }
    );
  }


  searchChecks() {
    this.isLoading = true;
    const fromDate = new Date(this.fromDateC);
    fromDate.setHours(0, 0, 0, 0);
    this.checksData = []

    const params = {
      doctorUID: this.doctorUIDc,
      fromDate: fromDate.toISOString(),
      collectable: this.paid,
      invoices: this.invoices,
      toDate: this.toDateC
    };

    this.billingService.searchChecks(params).subscribe(
      (result) => {
        this.isLoading = false;
        for(let i =0; i < result.length; i++)
          result[i].checkDate = new Date(result[i].checkDate);//make js dates so we can check if the check has reached paydate
        this.checksData = result;
      },
      (error) => {
        this.isLoading = false;
        console.error("Failed to search checks:", error);
      }
    );
  }

  invoiceForCheck(reciept:number, check: number){
    this.loadingCheck = check;
    this.billingService.makeInvoiceFromCheck(reciept, check).subscribe((data: any)=>{
      this.loadingCheck = null;
      for(let i=0; i < this.checksData.length; i++){
        if(this.checksData[i].AutoIndex == check){
          this.checksData[i].invoiceNumber = data.number;
          this.checksData[i].invoiced = new Date();
          this.checksData[i].isNew = true;
          this.checksData[i].invoiceLink = data.url.origin;
          break;
        }
      }
    },(error)=>{
      this.loadingCheck = null;
    })
  }

  invoicesSelection(){
    setTimeout(()=>{
      if(this.paid)
        this.invoices = '0';
    },1);
  }


}
